"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIntersection = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const dom_js_1 = require("../functions/dom.js");
/**
 * Hook that uses `IntersectionObserver` to trigger `onIntersect` callback when element is in viewport.
 * Callback is called only once by default (can be changed using the `once` parameter).
 * @returns a callback ref that needs to be set on the element you want to observe.
 * @private
 * @example
 * const onIntersection = React.useCallback(() => {
 *   console.log('Element is in viewport!');
 * }, []);
 * const ref = useIntersection(onIntersection);
 * return (<div ref={ref}>One of many elements</div>);
 */
const useIntersection = (onIntersect, options = {}, once = true) => {
    const { root, rootMargin, threshold } = options;
    const cleanupRef = React.useRef(() => { });
    const setRef = React.useCallback((node) => {
        var _a, _b;
        (_a = cleanupRef.current) === null || _a === void 0 ? void 0 : _a.call(cleanupRef);
        cleanupRef.current = () => { }; // ensure it doesn't try to clean up again
        if (!node || !((_b = (0, dom_js_1.getWindow)()) === null || _b === void 0 ? void 0 : _b.IntersectionObserver)) {
            return;
        }
        const observer = new IntersectionObserver(([entry], obs) => {
            if (entry.isIntersecting) {
                if (once) {
                    obs.disconnect();
                }
                onIntersect();
            }
        }, { root, rootMargin, threshold });
        observer.observe(node);
        cleanupRef.current = () => observer.disconnect();
    }, [onIntersect, once, root, rootMargin, threshold]);
    return setRef;
};
exports.useIntersection = useIntersection;
